import { textInputStyle } from '@/components/ui/Form/TextInput/style';
import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * DatePickerField のスタイル
 */
export const datePickerFieldStyle = tv({
    slots: {
        base: [
            textInputStyle(),
            textStyle({ color: 'base', size: 'sm' }),
            'h-[40px]',
            'bg-white',
            'py-10 px-8 xs:px-12',
            '[&>.react-datepicker-wrapper]:w-full',
        ],
    },
});
